/**
 * Quick Jump. Uses value from select field to redirect.
 *
 * <select class="js-quickview">
 *   <option value="https://www.example.com">...</option>
 * </select>
 */

const elements = Array.from(document.querySelectorAll('.js-quickview'));

export function init() {
	elements.forEach(element => element.addEventListener('change', quickView));
}

function quickView(event) {
	const { target } = event;

	if (target.tagName.toLowerCase() !== 'select') {
		return;
	}

	const selectedIndex = target.selectedIndex;
	const selectedValue = target.options[selectedIndex].value;

	if (selectedValue !== '') {
		window.location.href = selectedValue;
	}
}
